import { useIsTabletDimension } from '@beef/ui-kit';
import { compose } from '@beef/utils';
import { cnComponentsTheme } from '@carnica/ui-kit/styles';
import { Text } from '@carnica/ui-kit';
import { useIsMobileDimension } from '@carnica/utils/hooks';
import classNames from 'classnames/bind';
import React, { memo } from 'react';
import { createPortal } from 'react-dom';
import { areNonFunctionFieldsSame, findFirst } from "../../../../../../../utils/utils";
import { EZIndices } from "../../../../../../../../components/constants";
import { getPortalContainer } from "../../../../../../../../utils/window";
import { EModalStep } from "../EModalStep";
import { withLayoutAnalytics } from "../analytics/withAnalytics";
import { EChild, EStep } from "../constants";
import style from "./styles.pcss";
var cn = classNames.bind(style);
export var ModalLayoutMobile = compose(withLayoutAnalytics)( /*#__PURE__*/memo(function (props) {
  var zones = props.zones,
    className = props.className,
    _props$step = props.step,
    step = _props$step === void 0 ? EStep.Input : _props$step,
    isCombined = props.isCombined;
  var isMobile = useIsMobileDimension();
  var isTablet = useIsTabletDimension();
  return /*#__PURE__*/createPortal( /*#__PURE__*/React.createElement("div", {
    "aria-modal": "true",
    className: cn('wrapper', cnComponentsTheme()),
    style: {
      zIndex: EZIndices.Default
    },
    "data-t-id": "ModalLayout-ModalLayoutMobile"
  }, /*#__PURE__*/React.createElement("div", {
    className: cn('header'),
    style: {
      zIndex: EZIndices.Header
    }
  }, zones[EChild.Header]), /*#__PURE__*/React.createElement("div", {
    className: cn('content', className)
  }, step === EModalStep.Input && /*#__PURE__*/React.createElement("div", {
    className: cn('inputs')
  }, /*#__PURE__*/React.createElement("div", {
    className: cn('container')
  }, /*#__PURE__*/React.createElement("div", {
    className: cn('inputs-container')
  }, zones[EChild.Inputs]), isCombined && isTablet && zones[EChild.Payments]), /*#__PURE__*/React.createElement("div", {
    className: cn('button-container')
  }, zones[EChild.Button])), step === EModalStep.PaymentType && /*#__PURE__*/React.createElement("div", {
    className: cn('payments')
  }, /*#__PURE__*/React.createElement(Text, {
    variant: findFirst([isMobile && 'display-small', 'display-large'])
  }, "\u0441\u043F\u043E\u0441\u043E\u0431\u044B \u043E\u043F\u043B\u0430\u0442\u044B"), /*#__PURE__*/React.createElement("div", {
    className: cn('container')
  }, zones[EChild.Payments]), isCombined && /*#__PURE__*/React.createElement("div", {
    className: cn('button-container')
  }, zones[EChild.Button])))), getPortalContainer());
}, areNonFunctionFieldsSame));